export enum SystemStatusPageQaKeys {
  Banner = 'STATUS_PAGE_BANNER',
  MetaRow = 'STATUS_PAGE_META_ROW',
  Issues = 'STATUS_PAGE_ISSUES',
  IssueCard = 'STATUS_PAGE_ISSUE_CARD',
  IssueCardLabel = 'STATUS_PAGE_ISSUE_CARD_LABEL',
  IssueCardService = 'STATUS_PAGE_ISSUE_CARD_SERVICE',
  Summary = 'STATUS_PAGE_SUMMARY',
  Report = 'STATUS_PAGE_REPORT',
  ReportLine = 'STATUS_PAGE_REPORT_LINE',
}
